module.exports = __webpack_public_path__ + "static/media/AMAZON_POLISH_JAN.6dba0bc5.mp3";